import { render, staticRenderFns } from "./sopDetailRiskHazard.vue?vue&type=template&id=8dfb9304"
import script from "./sopDetailRiskHazard.vue?vue&type=script&lang=js"
export * from "./sopDetailRiskHazard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8dfb9304')) {
      api.createRecord('8dfb9304', component.options)
    } else {
      api.reload('8dfb9304', component.options)
    }
    module.hot.accept("./sopDetailRiskHazard.vue?vue&type=template&id=8dfb9304", function () {
      api.rerender('8dfb9304', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/pim/sopDetailRiskHazard.vue"
export default component.exports